// extracted by mini-css-extract-plugin
export default {"container":"styles__container--YLZxA","auraFadeIn":"styles__auraFadeIn--K4PUM"};